<script lang="ts">
  import SmartControl from "../components/organisms/SmartControl.svelte";
  import QueryClientDecorator from "../helpers/QueryClientDecorator.svelte";
  import type { Emodel } from "../helpers/types";

  interface Props {
    eModels: Emodel[];
    searchPlaceholder: string;
    showList?: boolean;
  }

  let { eModels, searchPlaceholder, showList = false }: Props = $props();
</script>

<QueryClientDecorator>
  <SmartControl {showList} {eModels} {searchPlaceholder} />
</QueryClientDecorator>
